/**
 * This mixin provides a common component interface that is shared by both the DirectoryImport and
 * DirectorySync components. It allows external links to be opened in a new window, to activate,
 * deactivate, import users from, and reactivate G Suite and Microsoft 365 directory integrations.
 * deactivate, import users from, and reactivate Google and Microsoft 365 directory integrations.
 * It uses polling to determine when the window that opens the external link has closed and emits
 * the externalWindowClosed event when that occurs.
 * @see https://stackoverflow.com/questions/9388380/capture-the-close-event-of-popup-window-in-javascript
 */
export default {
  props: {
    displayName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      eventName: 'externalWindowClosed',
      externalWindow: null,
      intervalId: null,
    };
  },

  methods: {
    clearInterval() {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    },

    isExternalWindowClosed() {
      if (this.externalWindow.closed) {
        this.externalWindow = null;
        this.clearInterval();
        this.$emit(this.eventName);
      }
    },

    openExternalLink(url) {
      this.externalWindow = this.openWindow(url);

      if (this.externalWindow) {
        this.intervalId = this.setInterval(() => this.isExternalWindowClosed(), 200);
      }
    },

    /**
     * Wrap global method for unit tests since global methods cannot be stubbed.
     */
    openWindow(url) {
      return window.open(url, '_blank');
    },

    /**
     * Wrap global method for unit tests since global methods cannot be stubbed.
     */
    setInterval(func, delay) {
      return window.setInterval(func, delay);
    },
  },
};
